import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';
import rem from '@/utils/rem'
import moment from 'moment'

export default function ViewFullMessage({
	visible,
	close,
	data
}) {

	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconConfigure />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Request for more Information Message
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						{/* <div style={{ fontSize: rem(14), textAlign: 'center' }}>Are you sure you want to cancel Simulation?</div> */}
						<div className="eclip-receipient__input">
							<div className='eclip-modal-receiver-data'>
								<div>
									From:
								</div>
								<div style={{marginLeft: 8}}>
									<div>{data?.orgName}</div>
									<div className='eclip-modal-receiver-email'>{data?.user}</div>
								</div>
							</div>
							<div className='eclip-modal-flex'>
								<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
									Message
								</span>
							<span className='eclip-modal--received'>
								Received on : {moment(new Date(data?.timestamp)).format('DD MMM, HH:MM')}
							</span>
							</div>
							<div className='eclip-model--view-message'>
								{data?.moreInfo}
							</div>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Close" submit={close} />
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
